<template>
    <div ref="canvas_container" style="width: 100%;height:180px;position: relative;background-color: rgb(26,26,26);">
            <canvas ref="scaleCanvas" style="height: 30px;width: calc(100% - 80px);position: absolute;left: 50px;top: 0;"/>
            <canvas ref="yAxiosCanvas" style="height: 180px;width: 50px;position: absolute;left: 0;top: 0;"></canvas>
            <div ref="wavContainer" style="height: 150px;width: calc(100% - 80px);position: absolute;left: 50px;top: 30px"></div>
            <canvas ref="selectedCanvas" style="position: absolute;left: 50px;top: 30px;z-index:8"></canvas>
            <canvas ref="gridCanvas" style="position: absolute;height:150px;width: calc(100% - 80px);left: 50px;top: 30px;z-index:1;"></canvas>

<!--        <div style="height: 30px; width: calc(100% - 145px);margin-left: 115px;">-->
<!--            <canvas ref="scaleCanvas"  />-->
<!--        </div>-->
<!--        <div style="height: 150px;width: 115px;background-color: goldenrod ;"></div>-->
<!--        <div ref="wavContainer" style="height:150px; width: calc(100% - 145px);position: absolute;left: 115px;top: 0;" />-->
    </div>
</template>

<script>
import WaveSurfer from "wavesurfer.js";
import CursorPlugin from "wavesurfer.js/dist/plugin/wavesurfer.cursor.min.js";
import RegionsPlugin from "wavesurfer.js/dist/plugin/wavesurfer.regions";

export default {
    props: {
        title: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            waveSurfer: null,
            scaleCanvas: null,
            scaleCanvasContext: null,
            scaleCanvasHeight: 30,
            selectedCanvas: null,
            selectedCanvasContext: null,
            selectedCanvasHeight: 150,
            yAxiosCanvas:null,
            yAxiosCanvasContext:null,
            gridCanvas:null,
            gridCanvasContext:null,
            mouseDown: false,
            totalSampleLen: 0,
            mouseStartX: 0,
            waveStartPos: 0,
            waveEndPos: 0,
            currentPos: 0,
            isUserPause: false,//是否人为暂停
            sampleRate: 8000,
            selectedStartPos: 0,
            wavLeftMargin: 50,//波形图距离左边的距离
            wavRightMargin: 30
        };
    },
    mounted() {
    },
    methods: {
        initPlayer() {
            this.initCanvas();
            this.waveSurfer = WaveSurfer.create({
                container: this.$refs.wavContainer,
                waveColor: "rgb(70,182,195)",
                progressColor: "rgb(70,182,195)",
                cursorColor: "#ffff00",
                backgroundColor: "#000000",
                // backgroundColor: "rgb(52 52 52 / 100%)",
                height: 150,
                plugins: [
                    CursorPlugin.create({
                        showTime: true,
                        opacity: 1,
                        customShowTimeStyle: {
                            "background-color": "#000",
                            color: "#fff",
                            padding: "2px",
                            "font-size": "8px",
                        },
                    }),
                    RegionsPlugin.create({}),
                ],
            });
            this.waveSurfer.on("ready", () => {
                this.waveSurfer.pause();
                this.totalSampleLen = this.sampleRate * this.waveSurfer.getDuration();
                this.waveEndPos = this.totalSampleLen;
                this.drawScale();
                this.drawY();
                this.selectedCanvas.addEventListener("mousedown", this.handleMouseDown, false);
                this.selectedCanvas.addEventListener("mousemove", this.handleMouseMove, false);
                this.selectedCanvas.addEventListener("mouseup", this.handleMouseUp, false);
                this.$emit("ready");
            });
            this.waveSurfer.on("play", () => {
                this.$emit("status-changed", this.title,"playing");
            });
            this.waveSurfer.on("pause", () => {
                this.$emit("status-changed",this.title, "pause");
            });
        },
        stop(){
            if (this.waveSurfer == null) {
                return;
            }
            this.waveSurfer.pause();
            this.waveSurfer.seekTo((this.selectedStartPos / this.sampleRate) / this.waveSurfer.getDuration());
        },
        play() {
            if (this.waveSurfer == null) {
                return;
            }
            if (this.waveSurfer.isPlaying()) {
                this.waveSurfer.seekTo((this.selectedStartPos / this.sampleRate) / this.waveSurfer.getDuration());
                // this.waveSurfer.pause();
                // this.isUserPause = true;
            } else {
                let endTime = this.selectedEndPos / this.sampleRate;
                if (this.selectedEndPos === this.selectedStartPos || this.selectedEndPos === 0) {
                    endTime = this.waveEndPos / this.sampleRate;
                }
                if (this.isUserPause) {//用户暂停，从原来位置播放
                    let startTime = this.waveSurfer.getCurrentTime();
                    this.waveSurfer.play(startTime, endTime);
                } else {//自动暂停，从选择区起点播放
                    let startTime = (this.selectedStartPos) / this.sampleRate;
                    this.waveSurfer.play(startTime, endTime);
                }
            }
        },
        initCanvas() {
            this.selectedCanvas = this.$refs.selectedCanvas;
            this.selectedCanvasContext = this.selectedCanvas.getContext('2d');
            this.selectedCanvas.width = this.$refs.canvas_container.clientWidth - this.wavLeftMargin - this.wavRightMargin;
            this.selectedCanvas.height = this.selectedCanvasHeight;
            this.selectedCanvasContext.clearRect(0, 0, this.selectedCanvas.width, this.selectedCanvasHeight);

            this.scaleCanvas = this.$refs.scaleCanvas;
            this.scaleCanvasContext = this.scaleCanvas.getContext('2d');
            this.scaleCanvas.width = this.$refs.canvas_container.clientWidth - this.wavLeftMargin - this.wavRightMargin;
            this.scaleCanvas.height = this.scaleCanvasHeight;

            this.yAxiosCanvas = this.$refs.yAxiosCanvas;
            this.yAxiosCanvasContext = this.yAxiosCanvas.getContext('2d');
            this.yAxiosCanvas.width = this.wavLeftMargin;
            this.yAxiosCanvas.height = this.selectedCanvasHeight;

            this.gridCanvas = this.$refs.gridCanvas;
            this.gridCanvasContext = this.gridCanvas.getContext('2d');
            this.gridCanvas.width = this.$refs.canvas_container.clientWidth - this.wavLeftMargin - this.wavRightMargin;
            this.drawGrid();
        },
        //绘制网格
        drawGrid(){
            this.gridCanvasContext.beginPath();
            this.gridCanvasContext.lineWidth = 0.5;
            this.gridCanvasContext.strokeStyle = "#979797";
            this.gridCanvasContext.moveTo(0, 20);
            this.gridCanvasContext.lineTo(this.gridCanvas.width, 20);
            this.gridCanvasContext.stroke();
            this.gridCanvasContext.moveTo(0, this.gridCanvas.height - 20);
            this.gridCanvasContext.lineTo(this.gridCanvas.width, this.gridCanvas.height - 20);
            this.gridCanvasContext.stroke();
            for (let i = 1; i < 9; i++) {
                this.gridCanvasContext.beginPath();
                this.gridCanvasContext.moveTo(this.gridCanvas.width/10*i, 0);
                this.gridCanvasContext.lineTo(this.gridCanvas.width/10*i, this.gridCanvas.height);
                this.gridCanvasContext.stroke();
            }
        },

        //绘制Y轴
        drawY(){
            this.yAxiosCanvasContext.clearRect(0, 0, this.yAxiosCanvas.width, this.yAxiosCanvas.height);

            let marginTop = 30;
            // let lineArray=[-1,"-∞",""];
            let lineArray=[-1,-5,-10];
            for (let i=0;i<lineArray.length;i++) {
                this.yAxiosCanvasContext.beginPath();
                this.yAxiosCanvasContext.lineWidth = 1;
                this.yAxiosCanvasContext.font = "lighter 12px Arial";
                this.yAxiosCanvasContext.strokeStyle = "rgb(125,125,125)";
                this.yAxiosCanvasContext.fillStyle = "white";
                let yVal = (1-Math.pow(10, lineArray[i]/20))*(this.yAxiosCanvas.height-marginTop)/2+marginTop;
                this.yAxiosCanvasContext.moveTo(this.yAxiosCanvas.width - 10, yVal);
                this.yAxiosCanvasContext.lineTo(this.yAxiosCanvas.width, yVal);
                this.yAxiosCanvasContext.fillText(lineArray[i], this.yAxiosCanvas.width - 35, yVal+3);
                this.yAxiosCanvasContext.stroke();

                yVal = this.yAxiosCanvas.height - yVal + marginTop;
                this.yAxiosCanvasContext.moveTo(this.yAxiosCanvas.width - 10, yVal);
                this.yAxiosCanvasContext.lineTo(this.yAxiosCanvas.width, yVal);
                this.yAxiosCanvasContext.fillText(lineArray[i], this.yAxiosCanvas.width - 35, yVal+3);
                this.yAxiosCanvasContext.stroke()
            }
            //画中间线
            this.yAxiosCanvasContext.beginPath();
            this.yAxiosCanvasContext.moveTo(this.yAxiosCanvas.width - 10, (this.yAxiosCanvas.height-marginTop)/2+marginTop);
            this.yAxiosCanvasContext.lineTo(this.yAxiosCanvas.width, (this.yAxiosCanvas.height-marginTop)/2+marginTop);
            this.yAxiosCanvasContext.fillText("-∞", this.yAxiosCanvas.width - 35, (this.yAxiosCanvas.height-marginTop)/2+3+marginTop);
            this.yAxiosCanvasContext.stroke();
            //画单位
            this.yAxiosCanvasContext.fillText("dB", 10,20);
            this.yAxiosCanvasContext.stroke();

        },
        drawScale() {
            this.scaleCanvasContext.clearRect(0, 0, this.scaleCanvas.width, this.scaleCanvas.height);
            this.scaleCanvasContext.fillStyle = "rgb(26,26,26)";
            this.scaleCanvasContext.fillRect(0, 0, this.scaleCanvas.width, this.scaleCanvas.height);
            let space = 100;
            this.waveStartPos = 0;
            let displayLen = this.waveEndPos - this.waveStartPos;
            let perLen = Math.round(displayLen / 100);
            for (let i = 0; i < space; i++) {
                this.scaleCanvasContext.beginPath();
                this.scaleCanvasContext.lineWidth = 1;
                this.scaleCanvasContext.font = "10px Arial";

                this.scaleCanvasContext.moveTo(this.scaleCanvas.width / space * i + 0.5, 15);
                if (i % 10 === 0) {
                    this.scaleCanvasContext.lineTo(this.scaleCanvas.width / space * i + 0.5, 25);
                    if (i > 0 && i < 100) {
                        this.scaleCanvasContext.fillStyle = "white";
                        let seconds = Math.round(perLen * i) + this.waveStartPos;
                        seconds = seconds / this.sampleRate;
                        let text = '';
                        if (seconds > 60) {
                            let minutes = parseInt(seconds / 60);
                            let second = parseInt(seconds - 60 * minutes);
                            if (second < 10) {
                                text = minutes + ':0' + second;
                            } else {
                                text = minutes + ':' + second;
                            }
                        } else {
                            text = seconds.toFixed(2);
                        }
                        this.scaleCanvasContext.fillText(text, (this.scaleCanvas.width / space * i) - 15, 10);
                    }
                } else if (i % 5 === 0) {
                    this.scaleCanvasContext.lineTo(this.scaleCanvas.width / space * i + 0.5, 20);
                }
                this.scaleCanvasContext.strokeStyle = "rgba(125,125,125,1.0)";
                this.scaleCanvasContext.fill();
                this.scaleCanvasContext.stroke();
            }
        },
        drawSelect() {
            //画频谱图的选中区
            if (this.selectedEndPos === 0) {
                return;
            }
            let dataLen = this.waveEndPos - this.waveStartPos;
            let startX = Math.round(((this.selectedStartPos - this.waveStartPos) / dataLen) * this.selectedCanvas.width);
            let endX = Math.round(((this.selectedEndPos - this.waveStartPos) / dataLen) * this.selectedCanvas.width);
            this.selectedCanvasContext.clearRect(0, 0, this.selectedCanvas.width, this.selectedCanvas.height);
            this.selectedCanvasContext.fillStyle = 'rgba(70,182,195,0.2)';
            this.selectedCanvasContext.lineWidth = 1;
            this.selectedCanvasContext.strokeStyle = 'rgb(255,255,0)';
            this.selectedCanvasContext.strokeRect(startX, 0, endX - startX, this.selectedCanvas.height);
            this.selectedCanvasContext.fillRect(startX, 0, endX - startX, this.selectedCanvas.height);
            //画波形图的选中区
            if (this.waveSurfer.regions.list['selectedRegion']) {
                this.waveSurfer.regions.list['selectedRegion'].remove();
            }
            this.waveSurfer.regions.add({
                id: 'selectedRegion',
                start: this.selectedStartPos / this.sampleRate,
                end: this.selectedEndPos / this.sampleRate,
                color: 'rgba(91,179,188,0.4)',
                drag: false,
                resize: false,
                handleStyle: {
                    left: {
                        width: '1px',
                        // backgroundColor:'transparent'
                    },
                    right: {
                        width: '1px',
                        // backgroundColor:'yellow'
                    }
                }
            })

        },
        handleMouseDown(e) {
            if (e.button !== 0) {
                return;
            }
            this.$emit("selectPlayer", this.title == '原始音频' ? 1 : 2);
            this.mouseDown = true;
            this.mouseStartX = e.offsetX;
            console.log('offsetX', e.offsetX);
            console.log('mouseStartX', this.mouseStartX);
            // this.$refs.contextMenu.style.display = "none";
        },
        handleMouseMove(e) {
            if (!this.mouseDown) return;
            if (this.totalSampleLen.length === 0) return;
            let dataLen = this.waveEndPos - this.waveStartPos;
            this.mouseEndX = e.offsetX;
            if (this.mouseStartX > this.mouseEndX) {
                this.selectedStartPos = Math.round((this.mouseEndX / this.selectedCanvas.width) * dataLen) + this.waveStartPos;
                this.selectedEndPos = Math.round((this.mouseStartX / this.selectedCanvas.width) * dataLen) + this.waveStartPos;
            } else {
                this.selectedStartPos = Math.round((this.mouseStartX / this.selectedCanvas.width) * dataLen) + this.waveStartPos;
                this.selectedEndPos = Math.round((this.mouseEndX / this.selectedCanvas.width) * dataLen) + this.waveStartPos;
            }
            // this.$emit('selected',this.selectedStartPos/16000,this.selectedEndPos/16000);
            this.currentPos = this.selectedStartPos;
            this.drawSelect();
        },
        handleMouseUp(e) {
            this.waveSurfer.pause()
            if (e.button !== 0) {
                return;
            }
            // if (this.howlerPlayer != null) {
            //   this.howlerPlayer.stop();
            // }
            // this.isUserPause = false;
            this.mouseDown = false;
            let dataLen = this.waveEndPos - this.waveStartPos;
            this.mouseEndX = e.offsetX;
            if (this.mouseStartX === this.mouseEndX) {
                this.selectedCanvasContext.clearRect(0, 0, this.selectedCanvas.width, this.selectedCanvas.height);
                this.selectedStartPos = Math.round((this.mouseStartX / this.selectedCanvas.width) * dataLen) + this.waveStartPos;
                this.selectedEndPos = this.selectedStartPos;
                this.currentPos = this.selectedStartPos;
                // this.drawProgressLine();
                this.$emit('interval-selected', this.selectedStartPos, this.selectedEndPos);
                if (this.waveSurfer.regions.list['selectedRegion']) {
                    this.waveSurfer.regions.list['selectedRegion'].remove();
                }
                this.waveSurfer.seekTo((this.selectedEndPos / this.sampleRate) / this.waveSurfer.getDuration());
                return;
            }

            if (this.mouseStartX > this.mouseEndX) {
                let tmp = this.mouseStartX;
                this.mouseStartX = this.mouseEndX;
                this.mouseEndX = tmp;
            }


            //X坐标转成采样点位置
            this.selectedStartPos = Math.round((this.mouseStartX / this.selectedCanvas.width) * dataLen) + this.waveStartPos;
            this.selectedEndPos = Math.round((this.mouseEndX / this.selectedCanvas.width) * dataLen) + this.waveStartPos;
            this.currentPos = this.selectedStartPos;
            this.$emit('interval-selected', this.selectedStartPos, this.selectedEndPos);
            this.drawSelect();
            this.waveSurfer.seekTo((this.selectedStartPos / this.sampleRate) / this.waveSurfer.getDuration());

            // this.clearProgressLine();

            // this.upWaveSurfer.on('region-created',function (region) {
            //   if (region.id===-1){
            //     that.upSelectedRegion = region;
            //     region.handleLeftEl.style.width = "1px";
            //     region.handleRightEl.style.width = "1px";
            //   }
            // });
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/audio-player.vue